import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const { language } = useLanguage();
  const isEnglish = language === 'en';

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-[calc(3.5rem+env(safe-area-inset-bottom,0px))] md:bottom-0 left-0 right-0 z-50 px-4 pb-2 md:pb-[env(safe-area-inset-bottom,8px)] pt-2 bg-background/95 backdrop-blur border-t border-border">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        <p className="text-xs text-muted-foreground truncate">
          <Cookie className="h-3.5 w-3.5 inline-block mr-1 -mt-0.5 text-primary" />
          {isEnglish
            ? 'We use cookies to improve your experience.'
            : 'Бид күүки ашигладаг.'}
          {' '}
          <a href="/privacy" className="text-primary hover:underline">
            {isEnglish ? 'Learn more' : 'Дэлгэрэнгүй'}
          </a>
        </p>
        <div className="flex items-center gap-1.5 shrink-0">
          <Button size="sm" variant="ghost" className="h-7 px-2 text-xs" onClick={handleDecline}>
            {isEnglish ? 'Decline' : 'Татгалзах'}
          </Button>
          <Button size="sm" className="h-7 px-3 text-xs" onClick={handleAccept}>
            {isEnglish ? 'Accept' : 'Зөвшөөрөх'}
          </Button>
        </div>
      </div>
    </div>
  );
}